import React from "react";

const RightFlap = () => {
  return (
    <svg
      className="right-flap"
      viewBox="0 0 185 325"
      preserveAspectRatio="none"
    >
      <path
        d="
          M 185 325
          L 185 0
          L 0 162
          Z
        "
        fill="currentColor"
      />
    </svg>
  );
};

export default RightFlap;